import(/* webpackMode: "eager" */ "/var/www/hoff/b2b_front/core/app/error.tsx")